module.exports = __webpack_public_path__ + "static/img/cartoon-child.4d2edaaa.png";